import { DEFAULT_COUNTRY_CODE, LOCAL_EN } from '@/config';
import { countries } from '@/constants';
import { checkPhoneNumberValidation, cleanNumber, cleanPhoneNumber } from '@/utils';
import { Select, Input, Image, Form, InputNumber, FormInstance } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  form: FormInstance;
  countryCodeName: string;
  phoneNumberName: string;
  phoneNumberPlaceholder: string;
  required?: boolean;
  onChange?: (value: string) => void;
  showCountryCode?: boolean;
}
export const PhoneNumberInput = ({
  form,
  required = true,
  countryCodeName,
  phoneNumberName,
  phoneNumberPlaceholder,
  onChange,
  showCountryCode = true,
}: Props) => {
  const { t, i18n } = useTranslation();

  const validatePhoneNumber = (_: any, phoneNumber: string) => {
    const countryCode = form.getFieldValue(countryCodeName);

    if (phoneNumber)
      if (!checkPhoneNumberValidation(phoneNumber, countryCode)) {
        return Promise.reject(new Error(String(t('invalid_phone_number'))));
      }
    return Promise.resolve();
  };

  return (
    <>
      {showCountryCode && (
        <Form.Item
          name={countryCodeName}
          className='mb-0'
          initialValue={DEFAULT_COUNTRY_CODE}
          rules={[{ required, message: '' }]}
        >
          <Select
            variant='borderless'
            style={{ direction: 'ltr' }}
            className='border border-solid custom-select-item custom-select-placeholder border-sd-input bg-sd-input-bg h-[40px] min-w-[120px] rounded-md'
            dropdownStyle={{ borderColor: 'red', borderWidth: '2px' }}
            showSearch
          >
            {countries.map((country, index) => (
              <Select.Option key={index} value={country.dialCode}>
                <span role='img'>
                  <Image preview={false} src={country.image} width={20} height={20} />
                </span>{' '}
                (+{country.dialCode})
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      )}

      <Form.Item
        className='w-full mb-0'
        name={phoneNumberName}
        rules={[
          { required, message: t('phone_number_is_required') },
          { validator: validatePhoneNumber },
        ]}
        validateTrigger='onBlur'
        style={{ direction: i18n.language === LOCAL_EN ? 'ltr' : 'rtl' }}
      >
        <InputNumber
          controls={false}
          formatter={(value) => value?.toString() || ''} // Format to display clean and english number
          parser={cleanNumber}
          autoComplete='off'
          placeholder={phoneNumberPlaceholder}
          onChange={(text) => onChange?.(text ?? '')}
          className='custom-input-number custom-input-number-without-controller border w-full border-solid border-sd-input bg-sd-input-bg custom-form-placeholder-input relative placeholder:text-GrayShade4 placeholder:font-[400] placeholder:text-sm placeholder:leading-5 h-[40px] rounded-md'
        />
      </Form.Item>
    </>
  );
};
